import * as React from 'react';
import * as styled from './styled';
import {BlockType} from 'api/task/types';
import {Block} from './components/Block';

/**
 * The content of a task progress.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Content(): React.ReactElement {
  return (
    <styled.Wrapper>
      <Block
        id="0"
        index={0}
        question="За кого получил зарплату пупа?"
        description="Небольшой тест, имеющий для вас большие последствия"
        type={BlockType.Test}
        score={10}
        answers={[
          {isTrue: false, text: 'За себя и за Сашку!'},
          {isTrue: true, text: 'За Лупу!', note: 'Молодец, ответил не правильно!'},
          {isTrue: false, text: 'Заворотнюк!'},
        ]}
      />
      <Block
        id="0"
        index={1}
        question="За кого получил зарплату пупа?"
        description="Напишите изложение, и пришлите его нам. Нам впринципе все равно, читать не будем."
        type={BlockType.FreeAnswer}
        score={10}
      />
      <Block
        id="0"
        index={2}
        question="За кого получил зарплату пупа?"
        type={BlockType.AutoCheck}
        answers={[]}
        score={10}
      />
      <Block
        id="0"
        index={3}
        question="За кого получил зарплату пупа?"
        type={BlockType.Classification}
        groups={[
          {title: 'Frontend', words: ['HTML5', 'CSS3', 'React']},
          {title: 'Backend', words: ['Laravel', 'Wordpress']},
        ]}
        score={10}
      />
      <Block
        id="0"
        index={4}
        question="За кого получил зарплату пупа?"
        type={BlockType.Accordance}
        pairs={[
          ['Крым', 'наш'],
          ['Кот', 'вискас'],
          ['GrowPlace', 'v. 1.0'],
        ]}
        score={10}
      />
    </styled.Wrapper>
  );
}
